import { device } from "@utils";
import styled from "styled-components";

export const StyledListPage = styled.section`
  padding: 38px 24px 38px 38px;
  overflow-y: scroll;
  height: 90vh;
  max-width: 1400px;
  @media ${device.tablet} {
    padding: 20px;
  }
`;

export const StyledInnerListPage = styled.section`
  background-color: #fff;
`;
export const StyledOuterListPage = styled.section`
  margin: 38px 24px 38px 38px;
  @media ${device.tablet} {
    padding: 20px;
  }
`;

export const StyledCreate = styled.section`
  padding-left: 18px;
  margin: 38px 24px 38px 38px;
  height: 90vh;
  overflow-y: scroll;
  form {
    max-width: 800px;
  }
  @media ${device.tablet} {
    margin: 16px;
    padding: 0;
    form {
      max-width: 460px;
      margin: auto;
    }
  }
`;

export const StyledCreateLg = styled.section`
  padding-left: 18px;
  margin: 38px 24px 38px 38px;
  height: 90vh;
  overflow-y: scroll;
  form {
    max-width: 960px;
  }
  @media ${device.tablet} {
    margin: 16px;
    padding: 0;
    form {
      max-width: 460px;
      margin: auto;
    }
  }
`;

export const StyledCreateXl = styled.section`
  padding-left: 18px;
  margin: 38px 24px 38px 38px;
  height: 90vh;
  overflow-y: scroll;
  form {
    max-width: 1120px;
  }
  @media ${device.tablet} {
    margin: 16px;
    padding: 0;
    form {
      max-width: 460px;
      margin: auto;
    }
  }
`;

export const StyledCreateContraception = styled(StyledCreate)`
  height: auto;
  overflow: hidden;
  form {
    &#contraception_form {
      max-width: 80%;
    }
    .ant-tabs-tab-btn {
      font-size: 20px;
    }
  }
  @media ${device.laptopL} {
    form {
      &#contraception_form {
        max-width: 90%;
      }
    }
  }
  @media ${device.laptop} {
    form {
      &#contraception_form {
        max-width: 100%;
      }
    }
  }
`;

export const StyledStaticPage = styled.section`
  padding: 38px 24px 38px 38px;
  overflow-y: scroll;
  height: 80vh;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  margin: 38px 24px 38px 38px;
  p {
    margin-bottom: 20px;
  }
  @media ${device.tablet} {
    padding: 20px;
  }
`;
export const StyledTermPage = styled.section`
  padding: 38px 24px 38px 38px;
  overflow-y: scroll;
  height: 90vh;
  /* background: #ffffff; */
  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2); */
  /* margin: 38px 24px 38px 38px; */
  p {
    margin-bottom: 20px;
  }
  ul {
    list-style: decimal;
    li {
      margin-bottom: 20px;
      ul {
        list-style: lower-alpha;
        margin-top: 10px;
      }
    }
  }
  @media ${device.tablet} {
    padding: 20px;
  }
`;
